/* eslint import/imports-first: 0 */
import React, { Component } from 'react';

class IsLoading extends Component {
    render() {
        return (
            <div className="spark-content__wrapper">
                <article className="spark-splash-screen spark-splash-screen--panel">
                    <section className="spark-splash-screen__content">
                        <div className="spark-panel spark-splash-screen__center col-xs-12 col-md-6 col-xl-4">
                            <div className="spark-panel__content">
                                <div className='spark-splash-screen__heading' >
                                    <img className="spark-splash-screen__logo" style={{height: '70px'}} src={'/public/images/aven-logo.png'} alt="logo" />
                                </div>
                                <h3 className="spark-splash-screen__heading">Booking Engine Designer</h3>
                            </div>
                        </div>
                    </section>
                </article>
            </div>
        );
    }
}

export default IsLoading;



// WEBPACK FOOTER //
// ./src/components/ui/IsLoading.js